/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReadNotificationCommandResult } from '../../models/read-notification-command-result';

export interface ApiNotificationCenterReadNotificationGet$Params {
  NotificationId?: string;
}

export function apiNotificationCenterReadNotificationGet(http: HttpClient, rootUrl: string, params?: ApiNotificationCenterReadNotificationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ReadNotificationCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNotificationCenterReadNotificationGet.PATH, 'get');
  if (params) {
    rb.query('NotificationId', params.NotificationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReadNotificationCommandResult>;
    })
  );
}

apiNotificationCenterReadNotificationGet.PATH = '/api/NotificationCenter/ReadNotification';
